var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrdersTable',{attrs:{"orders":_vm.openOrders,"title":"spotTrade.open-orders","selectable":true}}),_c('OrdersTable',{attrs:{"orders":_vm.completedOrders,"title":"spotTrade.order-history"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }